/* eslint-disable no-unused-vars */
import { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import MapGridZone from "./MapGridZone";
import MapCanvasZone from "./MapCanvasZone";
import { ZoneList, MapGrid_API, MapCanvas_API } from "../apiUtils";
import Sidebar from "../Sidebar/Sidebar";
import LoaderFull from "../../assets/images/loading.gif"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import NotificationPanel from "../Common/Notification";
import notificationicon from "../../assets/images/icons/notification.svg";
import OrangeStar from "../../assets/images/icons/orange-star.svg";
import ProfileLocation from "../../assets/images/icons/profile-location.svg"
import FillStar from "../../assets/images/icons/fill-star.svg"
import GrayStar from "../../assets/images/icons/gray-star.svg"
import BlackClose from "../../assets/images/icons/black-close.svg"
import RoleIcon from "../../assets/images/icons/Rolls-icon.svg"
import RoleIconWhite from "../../assets/images/icons/Roll-icon-white.svg"
import filterIcon from "../../assets/images/icons/filterIcon.svg"
import CommonFilter from "../Common/FilterCalendarMap";
import filterIconOrange from "../../assets/images/icons/filterIconOrange.svg"
import MemberBookingDropdown from "../Common/MemberBookingDropdown.jsx";
import CreditInfoCard from "../Common/CreditInfoCard";
import NoMap from "../../assets/images/icons/no-map.svg"
import CellLoader from "../../assets/images/icons/refreshloader.gif"
import WarningIcon from "../../assets/images/icons/Warningicon.svg"
import WarningcloseIcon from "../../assets/images/icons/close.svg"
import { useApiUiResponse } from "../../hooks/apiUiResponseHelper.js";
import { formatDate, parseDateStringToLocalDate } from "./dateUtils";
import guestConfirmation from "../../assets/images/icons/GuestConformation.svg"

// import {CustomSuccessToast} from "../Common/CustomToaster"

const SHARED_SELECTIONS_KEY = "sharedMapCalendarSelections";


export default function MapDefault() {
    const { t } = useTranslation()
    const location = useLocation();
    const [zones, setZones] = useState([]);
    const [selectedZone, setSelectedZone] = useState(null);
    const [zoneData, setZoneData] = useState(null);
    const [teamLeadFlag, setTeamLeadFlag] = useState("");
    const [loading, setLoading] = useState(true);

    const [layout, setLayout] = useState([]);
    const [vehicleType, setVehicleType] = useState([]);
    const [bookingtimeSlots, setBookingtimeSlots] = useState([]);

    const [bookingDate, setBookingDate] = useState(formatDate(new Date()));
    const [pickerMonth, setPickerMonth] = useState(new Date());
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

    const [startDate, setStartDate] = useState(formatDate(new Date()));
    const [changeddate, setchangeddate] = useState(formatDate(new Date()));

    const [holidaysList, setHolidaysList] = useState([]);
    const [lastDateBooking, setLastDateBooking] = useState("");

    // STATE
    const [spotVehicleMap, setSpotVehicleMap] = useState({});
    const [vehicleMap, setVehicleMap] = useState({});
    const [zoneOpen, setZoneOpen] = useState(false);
    // Team member dropdown state
    const [teamMemberList, setTeamMemberList] = useState([]);
    const [teamsList, setTeamsList] = useState([]);
    const [selectedTeamMember, setSelectedTeamMember] = useState("");
    const [selectedBookingFor, setSelectedBookingFor] = useState(null);

    const [selectedTeamId, setSelectedTeamId] = useState(null);
    const [isGuest, setIsGuest] = useState(0);
    const [zoneCreditValue, setZoneCreditValue] = useState(0);
    const [creditBalance, setCreditBalance] = useState(0);
    const [creditBalanceRefill, setCreditCreditBalance] = useState(0);
    const [zoneTypeforUserIcon, setZoneTypeforUserIcon] = useState("")

    const [showBookingForStaff, setShowBookingForStaff] = useState("");
    const [showAvailabilityColour, setShowAvailabilityColour] = useState("")
    const [mapFontSize, setMapFontSize] = useState("")

    const [removeBanner, setRemoveBanner] = useState("")

    const [leaveQueueParam, setLeaveQueueParam] = useState("")
    const [joinQueuueParam, setJoinQueueParam] = useState("")
    const [queuePositoin, setQueuePosition] = useState("")

    const [individualDayCost, setIndividualDayCost] = useState(0)

    const [GuestVehicle, setGuestVehicle] = useState({})

    const [showRoleIcons, setShowRoleIcons] = useState(location.state?.roleStatus == true ? true : false);

    const [preBookingQue, setPreBookingQue] = useState(null)
    const [preBookinQueCanvas, setPreBookingQueCanvas] = useState(null);

    const [mapZoomLevel, setMapZoomLevel] = useState("")

    const [parkingInformationImage, setParkingInformationImage] = useState("")

    const [checkOutBtn, setCheckOutBtn] = useState("")
    const [checkInBtn, setCheckInBtn] = useState("")
    const [checkInFlag, setCheckInFlag] = useState("")

    const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
    const [creditBalanceRefillEvery, setCreditBalanceRefillEvery] = useState("");
    const [isThumbnailPresent, setIsThumbnailPresent] = useState(0);
    const [companyId, setCompanyId] = useState(0);

    const [selectedName, setSelectedName] = useState("");

    const zoneDropdownRef = useRef(null);


    const [showFilter, setShowFilter] = useState(false);
    const [filters, setFilters] = useState({});
    const [filteredLayout, setFilteredLayout] = useState([]);
    const { handleApiUiResponse, renderApiUi } = useApiUiResponse(t);
    const history = useHistory();

    const selectedZoneId = location.state?.selectedZoneId;
    const selectedDate = location.state?.selectedDate;

    const getPickerDate = () => {
        if (!bookingDate) return null;

        return parseDateStringToLocalDate(bookingDate);
    };

    const normalizeBookingDate = (value, fallback = "") => {
        if (value instanceof Date) {
            return formatDate(value) || fallback;
        }

        if (typeof value === "string") {
            const parsed = parseDateStringToLocalDate(value);
            if (parsed) {
                return formatDate(parsed) || fallback;
            }
        }

        return fallback;
    };

    const isSameMonthAndYear = (date1, date2) => {
        if (!date1 || !date2) return false;

        return (
            date1.getMonth() === date2.getMonth() &&
            date1.getFullYear() === date2.getFullYear()
        );
    };

    const formatPickerInputValue = (date) => {
        if (!date) return "";

        return date.toLocaleDateString("en-GB", {
            weekday: "short",
            day: "2-digit",
            month: "short"
        });
    };

    useEffect(() => {
        const currentPickerDate = getPickerDate();
        if (currentPickerDate) {
            setPickerMonth(currentPickerDate);
        }
    }, [bookingDate]);

    const getSharedSelections = () => {
        try {
            const raw = sessionStorage.getItem(SHARED_SELECTIONS_KEY);
            return raw ? JSON.parse(raw) : {};
        } catch (error) {
            console.error("Error reading shared selections:", error);
            return {};
        }
    };

    const saveSharedSelections = (overrides = {}) => {
        try {
            const current = getSharedSelections();
            sessionStorage.setItem(
                SHARED_SELECTIONS_KEY,
                JSON.stringify({
                    ...current,
                    ...overrides,
                })
            );
        } catch (error) {
            console.error("Error saving shared selections:", error);
        }
    };

    // useEffect(() => {
    //     if (selectedDate) {
    //         setBookingDate(selectedDate);
    //         setStartDate(selectedDate);
    //         setchangeddate(selectedDate);
    //     }
    // }, [selectedDate]);

    // useEffect(() => {
    //     if (selectedZoneId && zones.length > 0) {
    //         const foundZone = zones.find(z => z.Id === selectedZoneId);
    //         if (foundZone) {
    //             updateSelectedZone(foundZone, selectedDate || bookingDate);
    //         }
    //     }
    // }, [selectedZoneId, zones]);
    
     const [isTagListDataEmpty, setIsTagListDataEmpty] = useState(true);
    
        useEffect(() => {
            const tagListData = zoneData?.TagListData;
    
            if (!tagListData) {
                setIsTagListDataEmpty(true);
                return;
            }
    
            const areAllArraysEmpty = Object.values(tagListData).every(
                (list) => Array.isArray(list) && list.length === 0
            );
            console.log(areAllArraysEmpty, "areAllArraysEmpty")
    
            setIsTagListDataEmpty(areAllArraysEmpty);
        }, [zoneData?.TagListData]);


     useEffect(() => {
        document.title = `${t("map")} | Ronspot`
      }, []);

    // Custom function to update selectedZone data cleanly
    const updateSelectedZone = (zone, date) => {
        setSelectedZone({
            ...zone,
            MapType: parseInt(zone.MapType, 10),
            bookingDate: date,
        });
        saveSharedSelections({
            zoneId: zone?.Id ?? null,
            zoneName: zone?.ZoneName ?? "",
        });
    };

    const resetMemberDropdownToDefault = () => {
        const defaultMember = teamMemberList[0];

        if (defaultMember) {
            setSelectedTeamMember(defaultMember.GuId);
            setSelectedTeamId(null);
            setIsGuest(defaultMember.GuId === "0" ? 1 : 0);
            setSelectedName(defaultMember.FullName);
        } else {
            setSelectedTeamMember("");
            setSelectedTeamId(null);
            setIsGuest(0);
            setSelectedName("");
        }
    };

    const handleMemberSelection = async (member,teamMemberGuId) => {
        setSelectedTeamMember(member.GuId);
        setSelectedTeamId(null);
        setIsGuest(member.GuId === "0" ? 1 : 0);
        setSelectedName(member.FullName);
        saveSharedSelections({
            teamMemberId: member.GuId,
            teamId: null,
            isGuest: member.GuId === "0" ? 1 : 0,
            selectedName: member.FullName,
        });
        setLoading(true);

        try {
            const guidToPass = teamMemberGuId || member?.GuId || "";
            console.log(guidToPass,"guidToPassguidToPass")
            const response = await ZoneList(guidToPass);
            const zoneList = response?.Data?.Records?.ZoneList || [];
            const responseCode = response?.Data?.ResponseCode;

            handleApiUiResponse(response, {
                    successToaster: 0,
                    errorToaster: 1,
                    alertPopup: 1
                });

            if (responseCode === 453) {
                resetMemberDropdownToDefault();
                return;
            }


            if (zoneList.length > 0) {
                setZones(zoneList);

                const selectedZoneMatch = zoneList.find((zone) => zone.Id === selectedZone?.Id);
                const defaultZone = zoneList.find((zone) => zone.DefaultId === 1);

                const resolvedZone = responseCode === 448
                    ? (defaultZone || selectedZoneMatch || zoneList[0])
                    : (selectedZoneMatch || defaultZone || zoneList[0]);

                if (resolvedZone) {
                    updateSelectedZone(resolvedZone, bookingDate);
                }
            }

            if (response?.Data?.ResponseCode === 423) {
                window.location.href = "/calendar";
                return;
            }
        } catch (error) {
            console.error("Error fetching member zones:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleTeamSelection = async (team) => {
        setSelectedTeamMember("");
        setSelectedTeamId(team.Id);
        setIsGuest(0);
        setSelectedName(team.Name);
        saveSharedSelections({
            teamMemberId: "",
            teamId: team.Id,
            isGuest: 0,
            selectedName: team.Name,
        });

        if (!selectedZone || selectedZone.MapType === 1) return;

        const activeFilters = getStoredFilters(selectedZone.Id);

        await fetchZoneData(
            selectedZone,
            bookingDate,
            "",
            team.Id,
            0,
            activeFilters
        );
    };

    // useEffect 1: Fetch Zone List and determine initial zone/date
    useEffect(() => {
        const fetchZoneList = async () => {
            setLoading(true);
            try {
                const sharedSelections = getSharedSelections();
                const guidToPass = sharedSelections.teamMemberId || selectedTeamMember || "";
                const response = await ZoneList(guidToPass);
                console.log(guidToPass, "ZoneList request GUID (MapDefault.jsx)")

                handleApiUiResponse(response, {
                    successToaster: 0,
                    errorToaster: 1,
                    alertPopup: 1
                });

                if (response?.Data?.ResponseCode === 200) {
                    const zoneList = response.Data.Records.ZoneList || [];
                    setZones(zoneList);

                    const params = new URLSearchParams(location.search);
                    const urlZoneId = params.get("zoneId");
                    const urlBookingDate = params.get("bookingDate");

                    const today = formatDate(new Date());

                    // ⭐ PRIORITY ORDER
                    const finalDate = normalizeBookingDate(
                        selectedDate || urlBookingDate || today,
                        today
                    );

                    const finalZoneId =
                        selectedZoneId || urlZoneId || sharedSelections.zoneId;

                    if (sharedSelections.teamMemberId || sharedSelections.teamId != null) {
                        setSelectedTeamMember(sharedSelections.teamMemberId || "");
                        setSelectedTeamId(sharedSelections.teamId ?? null);
                        setIsGuest(sharedSelections.isGuest ?? 0);
                        setSelectedName(sharedSelections.selectedName || "");
                    }

                    setBookingDate(finalDate);

                    // find zone
                    let foundZone = null;

                    if (finalZoneId) {
                        foundZone = zoneList.find(
                            z => z.Id.toString() === finalZoneId.toString()
                        );
                    }

                    if (!foundZone) {
                        foundZone = zoneList.find(z => z.DefaultId === 1);
                    }

                    if (foundZone) {
                        updateSelectedZone(foundZone, finalDate);
                    }
                    // const params = new URLSearchParams(location.search);
                    // const urlZoneId = params.get("zoneId");
                    // const urlBookingDate = params.get("bookingDate");
                    // const today = formatDate(new Date());

                    // const dateToUse = urlBookingDate || today;
                    // setBookingDate(dateToUse);

                    // const defaultZone = zoneList.find((z) => z.DefaultId === 1);

                    // let foundZone = null;

                    // if (urlZoneId) {
                    //     foundZone = zoneList.find(
                    //         (z) => z.Id.toString() === urlZoneId.toString()
                    //     );
                    // } else {
                    //     foundZone = defaultZone;
                    // }

                    // if (foundZone) {
                    //     updateSelectedZone(foundZone, dateToUse);
                    // }
                }

                // if (response?.Data?.ResponseCode === 423) {
                //     window.location.href = "/calendar";
                //     return;
                // }
            } catch (error) {
                console.error("Error fetching zones:", error);
            } finally {
                setLoading(false);
                // Keep loading until Map data is fetched in the next useEffect
            }
        };

        fetchZoneList();
    }, [location.search]);

    // const fetchZoneData = async (zone, date, teamMemberGuId, teamId, isGuest) => {
    //     console.log("Fetching data for zone000", teamMemberGuId);
    //     setLoading(true);
    //     try {
    //         let response = null;
    //         const dateToFetch = date || bookingDate;
    //         // Pass teamMemberGuId to API if present
    //         if (zone.MapType === 2) {
    //             response = await MapGrid_API(zone.Id, dateToFetch, teamMemberGuId, teamId, isGuest);
    //         } else if (zone.MapType === 3) {
    //             response = await MapCanvas_API(zone.Id, dateToFetch, teamMemberGuId, teamId, isGuest);
    //         }
    const fetchZoneData = async (zone, date, teamMemberGuId, teamId, isGuest, filters) => {
        console.log("Fetching data for zone000", date, teamMemberGuId, teamId, isGuest, filters, "=FILTERS");

        setLoading(true);

        try {
            let response = null;
            
            const dateToFetch = date || bookingDate;

            // ✅ IMPORTANT: never send null
            const safeTeamId = teamId ?? 0;
            const safeIsGuest = isGuest ?? 0;

            if (zone.MapType === 2) {
                response = await MapGrid_API(
                    zone.Id,
                    dateToFetch,
                    teamMemberGuId,
                    safeTeamId,
                    safeIsGuest,
                    filters
                );
            } else if (zone.MapType === 3) {
                response = await MapCanvas_API(
                    zone.Id,
                    dateToFetch,
                    teamMemberGuId,
                    safeTeamId,
                    safeIsGuest,
                    filters
                );
            }

            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1,
                onConfirmByCode: {
                    443: () => history.push("/calendar")
                }
            });
            

            if (response?.Data?.ResponseCode === 448) {
                setZoneData(null);
                setLayout([]);
                setFilteredLayout([]);
                setVehicleMap({});
                setSpotVehicleMap({});
                setGuestVehicle({});
                return;
            }
            
            // const responseData = await response.json()
            // const isOk = CustomSuccessToast(responseData);
            // console.log(isOk,"-------------------------")

        //     if (!isOk) {
        //     setZoneData(null);
        //     return; // Stop execution here for 401, 423, etc.
        // }

            if (response?.Data?.ResponseCode === 200) {
                const layouts = response.Data?.Records?.Layout || [];

                const HolidaysList = response.Data?.Records?.HolidaysZoneWise || [];
                setHolidaysList(HolidaysList);

                const LastDateBooking = response.Data?.Records?.LastDateOfBookingAvailable || "";
                setLastDateBooking(LastDateBooking);

                const zoneCreditValue = response.Data?.Records?.ZoneCreditValue
                setZoneCreditValue(zoneCreditValue);

                const IndividualDayCost = response.Data?.Records?.IndividualDayCost
                setIndividualDayCost(IndividualDayCost)

                // const userCredits = response.Data?.Records?.CreditBalance || 0;
                // setCreditBalance(userCredits);

                const CreditBalanceRefill = response.Data?.Records?.CreditBalanceRefillEvery;
                setCreditCreditBalance(CreditBalanceRefill);

                const ZoneTypeforUserIcon = response.Data?.Records?.IsDisplayEmployeeRoleToggle;
                setZoneTypeforUserIcon(ZoneTypeforUserIcon)

                const showBookingForStaff = response.Data?.Records?.ShowBookingForStaff;
                const showAvailabilityColour = response.Data?.Records?.ShowAvailabilityColour;
                const mapFontSize = response.Data?.Records?.FontMapSize;

                setShowBookingForStaff(showBookingForStaff);
                setShowAvailabilityColour(showAvailabilityColour);
                setMapFontSize(mapFontSize);

                const removeBanner = showBookingForStaff ==0 && showAvailabilityColour ==3

                setRemoveBanner(removeBanner)

                const LeaveQueParam = response?.Data?.Records?.JoinedQueue
                setLeaveQueueParam(LeaveQueParam)

                const JoinQueParam = response?.Data?.Records?.DisplayQueue
                setJoinQueueParam(JoinQueParam)

                const UserQueuePosition = response?.Data?.Records?.QueuePosition
                setQueuePosition(UserQueuePosition)

                const checkInTypesAPI = Array.isArray(response?.Data?.Records?.CheckInType)
                    ? response?.Data?.Records?.CheckInType
                    : response?.Data?.Records?.CheckInType != null
                        ? [response?.Data?.Records?.CheckInType]
                        : [];

                const checkInTypes = checkInTypesAPI.includes(2);

                const showcheckOutButton = checkInTypesAPI.includes(0) ? false : true;

                const checkInFlag = response?.Data?.Records?.CheckInFlag
                setCheckInFlag(checkInFlag)

                const checkInButton = checkInTypes && (response?.Data?.Records?.CheckInFlag === 0 || response?.Data?.Records?.CheckInFlag === 2);
                setCheckInBtn(checkInButton)

                const checkOutButton = showcheckOutButton && response?.Data?.Records?.CheckInFlag === 1;
                setCheckOutBtn(checkOutButton)

                console.log(checkInFlag,"checkInTypesAPIcheckInTypesAPI")

                const PreBookingQue = response.Data?.Records?.PreBookQuestion;
                setPreBookingQue(PreBookingQue ? PreBookingQue.replace(/<\/?p>/g, "").trim() : "")

                const PreBookingQueCanvas = response.Data?.Records?.PreBookingQuestion
                setPreBookingQueCanvas(PreBookingQueCanvas ? PreBookingQueCanvas.replace(/<\/?p>/g, "").trim() : "");

                const MapZoomLevelAPI = response?.Data?.Records?.MapZoomLevel
                const MapZoomLevel = MapZoomLevelAPI ? MapZoomLevelAPI / 100 : 1
                setMapZoomLevel(MapZoomLevelAPI)

                const records = response?.Data?.Records;
                // If ParkingInformation is a string and not empty, set it; otherwise, set null
                const infoUrl = (records?.ParkingInformation && records.ParkingInformation.trim() !== "")
                    ? records.ParkingInformation
                    : null;

                setParkingInformationImage(infoUrl);

                console.log(PreBookingQueCanvas, "PREBOOKQUWER")
                //Vehicles mapping
                const vehicleMap = {};
                layouts.forEach(layout => {
                    vehicleMap[layout.SpotId] = layout.EmployeeVehicleType || []
                });
                console.log(vehicleMap, "Vehicekekek")
                // TeamMember Name mapping
                const GuestVehicle = {};
                layouts.forEach(layout => {
                    GuestVehicle[layout.SpotId] = layout.GuestVehicleTypes || []
                });
                console.log(GuestVehicle, "guesererfmkmoef")

                const TeamMemberlist = response.Data?.Records?.TeamMemberList || [];
                setTeamMemberList(TeamMemberlist);

                console.log(TeamMemberlist,"TeamMemberlistTeamMemberlist")

                setCreditBalance(records.CreditBalance);
                setCompanyId(records.CompanyId);
                setCreditBalanceRefillEvery(records.CreditBalanceRefillEvery);
                setIsThumbnailPresent(records.IsThumbnailPresent);
                // Teams mapping
                const TeamsArr = response.Data?.Records?.Teams || [];
                setTeamsList(TeamsArr);
                setVehicleMap(vehicleMap);
                setSpotVehicleMap(vehicleMap);
                setGuestVehicle(GuestVehicle)
                setZoneData(response.Data.Records);
                setTeamLeadFlag(response.Data.Records.TeamLeadFlag);
                setLayout(layouts);
            }
            else if (response?.Data?.ResponseCode === 423) {
                window.location.href = "/calendar";
                return;
            } else {
                console.error("Failed to load zone data");
                setZoneData(null);
            }
        } catch (error) {
            console.error("Error fetching zone data:", error);
            setZoneData(null);
        } finally {
            setLoading(false);
        }
    };


    // Set default team member after teamMemberList is set, but only if not already selected
    useEffect(() => {
        if (teamMemberList.length > 0 && !selectedTeamMember && !selectedTeamId) {
            setSelectedTeamMember(teamMemberList[0].GuId);
            setIsGuest(teamMemberList[0].GuId === "0" ? 1 : 0);
            setSelectedName(teamMemberList[0].FullName);
        }
    }, [teamMemberList]);

    useEffect(() => {
        if (!selectedZone?.Id && !selectedTeamMember && selectedTeamId == null && !selectedName) {
            return;
        }

        saveSharedSelections({
            zoneId: selectedZone?.Id ?? null,
            zoneName: selectedZone?.ZoneName ?? "",
            teamMemberId: selectedTeamMember || "",
            teamId: selectedTeamId ?? null,
            isGuest: isGuest ?? 0,
            selectedName: selectedName || "",
        });
    }, [selectedZone, selectedTeamMember, selectedTeamId, isGuest, selectedName]);

    useEffect(() => {
        console.log("DATE Usadfasdfsadfaf:", bookingDate);
    }, [bookingDate]);


    // useEffect(() => {
    //     if (!selectedZone || selectedZone.MapType === 1) return;

    //     fetchZoneData(
    //         selectedZone,
    //         bookingDate,
    //         selectedTeamMember || "",
    //         selectedTeamId || "",
    //         isGuest ?? 0
    //     );

    // }, [selectedZone, bookingDate, selectedTeamMember, selectedTeamId, isGuest]);



    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                zoneDropdownRef.current &&
                !zoneDropdownRef.current.contains(event.target)
            ) {
                setZoneOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
    setFilteredLayout(layout);
}, [layout]);

const applyGridFilter = (filters) => {
    let filtered = [...layout];

    // ✅ Facility filter (based on SpotType)
    if (filters.facility) {
        filtered = filtered.filter(
            item => item.SpotType === Number(filters.facility)
        );
    }

    // ✅ Time filter (if your API supports it)
    if (filters.time) {
        filtered = filtered.filter(item =>
            item.AvailableTimes?.includes(filters.time)
        );
    }

    setFilteredLayout(filtered);
};

const getStoredFilters = (zoneId) => {
    const stored = sessionStorage.getItem(`mapFilters_${zoneId}`);
    if (!stored) return {};

    const parsed = JSON.parse(stored);
    return {
        ...parsed,
        FacilityFilter: parsed.FacilityFilterApiValue ?? parsed.FacilityFilter ?? "",
    };
};

useEffect(() => {
    if (!selectedZone?.Id) return;

    const stored = sessionStorage.getItem(`mapFilters_${selectedZone.Id}`);
    const parsed = stored ? JSON.parse(stored) : {};

    // ✅ SET ONLY CURRENT ZONE FILTER
    setFilters(parsed);

}, [selectedZone]);

useEffect(() => {
    if (!selectedZone || selectedZone.MapType === 1) return;

    const parsedFilters = getStoredFilters(selectedZone.Id);

    fetchZoneData(
        selectedZone,
        bookingDate,
        selectedTeamMember || "",
        selectedTeamId || "",
        isGuest ?? 0,
        parsedFilters // ✅ ALWAYS fresh per zone
    );

}, [
    selectedZone,
    bookingDate
]);

    useEffect(() => {
        const today = formatDate(new Date());
        const fallbackDate = normalizeBookingDate(selectedZone?.bookingDate, today) || today;
        const normalizedBookingDate = normalizeBookingDate(bookingDate, fallbackDate);

        if (!normalizedBookingDate) {
            return;
        }

        if (bookingDate !== normalizedBookingDate) {
            setBookingDate(normalizedBookingDate);
            return;
        }

        if (!normalizeBookingDate(startDate)) {
            setStartDate(normalizedBookingDate);
        }

        if (!normalizeBookingDate(changeddate)) {
            setchangeddate(normalizedBookingDate);
        }
    }, [bookingDate, changeddate, selectedZone?.bookingDate, startDate]);

    const handleDateChange = (event) => {
        const newDate = event.target.value;
        setBookingDate(newDate);
        setStartDate(newDate);
        // This is the "magic" line that pushes the date to the second picker
        setchangeddate(newDate);
        // fetchZoneData(selectedZone, newDate);
    };

    const handleZoneChange = (e) => {
        const selected = zones.find(z => z.Id === Number(e.target.value));
        updateSelectedZone(selected, bookingDate);

    };

    const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const isHoliday = (date) => {
        return holidaysList.includes(formatLocalDate(date));
    };

    const isLastDateBooking = lastDateBooking
        ? new Date(`${lastDateBooking}T00:00:00`)
        : null;

    const getFirstName = () => sessionStorage.getItem("firstname");

    const selectedMemberData =
        teamMemberList.find(m => m.GuId === selectedTeamMember);
    const selectedMemberCredit = selectedMemberData?.Credit ?? creditBalance;
    console.log(selectedMemberCredit,"selectedMemberCreditselectedMemberCredit")
    const selectedMemberCreditBalanceRefillEvery =
        selectedMemberData?.CreditBalanceRefillEvery ?? creditBalanceRefillEvery;
    const selectedCreditPersonName =
        isGuest === 1
            ? ""
            : (selectedMemberData?.FullName || selectedName || "");

    const syncZoneUiFlagsFromRecords = (records) => {
        if (!records) return;

        const checkInTypesAPI = Array.isArray(records?.CheckInType)
            ? records.CheckInType
            : records?.CheckInType != null
                ? [records.CheckInType]
                : [];

        const allowCheckIn = checkInTypesAPI.includes(2);
        const hideCheckOut = checkInTypesAPI.includes(0);
        const nextCheckInFlag = records?.CheckInFlag;

        setCheckInFlag(nextCheckInFlag);
        setCheckInBtn(
            allowCheckIn && (nextCheckInFlag === 0 || nextCheckInFlag === 2)
        );
        setCheckOutBtn(!hideCheckOut && nextCheckInFlag === 1);
    };

    const syncCreditInfoFromRecords = (records) => {
        if (!records) return;

        const nextTeamMemberList = Array.isArray(records?.TeamMemberList)
            ? records.TeamMemberList
            : [];

        setTeamMemberList(nextTeamMemberList);
        setCreditBalance(records?.CreditBalance ?? 0);
        setCreditBalanceRefillEvery(records?.CreditBalanceRefillEvery ?? "");
        setZoneCreditValue(records?.ZoneCreditValue ?? 0);
        setCompanyId(records?.CompanyId ?? 0);
        setIsThumbnailPresent(records?.IsThumbnailPresent ?? 0);
    };

    const refreshZoneAfterBooking = async (zoneOrDate = selectedZone, dateOverride = bookingDate) => {
        const resolvedZone =
            zoneOrDate && typeof zoneOrDate === "object" && "Id" in zoneOrDate
                ? zoneOrDate
                : selectedZone;

        const today = formatDate(new Date());
        const resolvedDate = normalizeBookingDate(
            typeof zoneOrDate === "string"
                ? zoneOrDate
                : (dateOverride || bookingDate),
            normalizeBookingDate(selectedZone?.bookingDate, today) || today
        );

        if (!resolvedZone || !resolvedDate) return;

        setBookingDate(resolvedDate);
        setStartDate(resolvedDate);
        setchangeddate(resolvedDate);

        await fetchZoneData(
            resolvedZone,
            resolvedDate,
            selectedTeamMember || "",
            selectedTeamId || 0,
            isGuest ?? 0
        );
    };

const isFilterApplied = (zoneId) => {
    const stored = sessionStorage.getItem(`mapFilters_${zoneId}`);
    if (!stored) return false;

    const filters = JSON.parse(stored);

    return Object.values(filters).some((val) => {
        if (Array.isArray(val)) {
            return val.length > 0;
        }

        return val !== "" && val !== null && val !== undefined;
    });
};

    const monthNames = [
        t("January"), t("February"), t("March"), t("April"),
        t("May"), t("June"), t("July"), t("August"),
        t("September"), t("October"), t("November"), t("December")
    ];
    const shortMonthNames = [
        t("month_3digit_of_january"), t("month_3digit_of_february"), t("month_3digit_of_march"), t("month_3digit_of_april"),
        t("month_3digit_of_may"), t("month_3digit_of_june"), t("month_3digit_of_july"), t("month_3digit_of_august"),
        t("month_3digit_of_september"), t("month_3digit_of_october"), t("month_3digit_of_november"), t("month_3digit_of_december")
    ];

console.log(selectedName,"selectedNameasfdfsaf")

    const headerTitle = t("react_hi").replace("%s", getFirstName());

    return (
            <div className="content-area">
                <header className="header-container header">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-2">
                                <div className="greeting-title">
                                    <p>{headerTitle}</p>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <form className="d-flex justify-content-center custom-inline-dropdown gap-3">

                                    <div className="filter-panel d-flex justify-content-end align-items-center gap-3">
                                        <div className="filter-options d-flex gap-3 w-100">
                                        {/* <div className="filter-icon" data-bs-toggle="modal" data-bs-target="#filterPopup"> */}
                                        {/* <div className="filter-icon">
                                            <img src={filterIcon} alt="" onClick={() => setShowFilter(true)}/>                                            
                                        </div> */}
                                        {!isTagListDataEmpty == true && (selectedZone.MapType === 2 || selectedZone.MapType === 3) &&
                                        <div className="filter-icon" onClick={() => setShowFilter(true)}>
                                            {selectedZone?.Id && isFilterApplied(selectedZone.Id) ? (
                                                <img src={filterIconOrange} alt="Filter Applied" />
                                            ) : (
                                                <img src={filterIcon} alt="No Filter" />
                                            )}
                                        </div>
                                        }

                                            {/* ================= DATE DROPDOWN ================= */}
                                            {/* <div className="employee-list " style={{ position: "relative" }}>
                                                <div
                                                    className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <div className="d-flex flex-column">
                                                        <p className="sub-dropdown-name">Date</p>
                                                        <input
                                                            type="date"
                                                            value={bookingDate}
                                                            onChange={handleDateChange}
                                                            min={new Date().toISOString().split("T")[0]}
                                                            style={{
                                                                border: "none",
                                                                outline: "none",
                                                                fontSize: "16px",
                                                                fontWeight: "bold",
                                                                color: "#1c988a",
                                                                background: "transparent",
                                                                cursor: "pointer",
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className="booking-date">
                                                <label className="popup-inner-title m-0" htmlFor="CustomDatePicker">
                                                    {t("date")}
                                                
                                                {/* <DatePicker
                                                    selected={bookingDate ? new Date(bookingDate) : null}
                                                    onChange={(date) => {
                                                        if (!date) return;
                                                        const formatted = date.toISOString().split("T")[0];
                                                        setBookingDate(formatted);
                                                    }}

                                                    minDate={new Date()}
                                                    maxDate={isLastDateBooking}
                                                    dateFormat="dd MMMM"
                                                    shouldCloseOnSelect={true}
                                                    showPopperArrow={false}
                                                    calendarStartDay={1}
                                                    placeholderText="Select Date"
                                                    style={{ width: "100%" }}
                                                    className="custom-datepicker-input"

                                                    filterDate={(date) => !isHoliday(date)}
                                                    dayClassName={(date) =>
                                                        isHoliday(date) ? "react-datepicker__day--holidayClass" : undefined
                                                    }
                                                /> */}

                                                <DatePicker
                                                    selected={getPickerDate()}
                                                    open={isDatePickerOpen}
                                                    openToDate={getPickerDate() || pickerMonth}
                                                    calendarClassName="custom-date-picker-calendar"
                                                    onInputClick={() => {
                                                        setIsDatePickerOpen((prev) => !prev);
                                                    }}
                                                    onCalendarOpen={() => {
                                                        const currentPickerDate = getPickerDate();
                                                        setPickerMonth(currentPickerDate || new Date());
                                                    }}
                                                    onCalendarClose={() => {
                                                        setIsDatePickerOpen(false);
                                                        const currentPickerDate = getPickerDate();
                                                        if (currentPickerDate) {
                                                            setPickerMonth(currentPickerDate);
                                                        }
                                                    }}
                                                    onMonthChange={(date) => {
                                                        setPickerMonth(date);
                                                    }}
                                                    onChange={(date) => {
                                                        if (!date) return;

                                                        const formatted = formatDate(date);

                                                        setBookingDate(formatted);
                                                        setStartDate(formatted);
                                                        setchangeddate(formatted);
                                                        setIsDatePickerOpen(false);
                                                    }}
                                                    onClickOutside={() => {
                                                        setIsDatePickerOpen(false);
                                                    }}
                                                    minDate={new Date()}
                                                    maxDate={isLastDateBooking}
                                                    dateFormat="EEE dd MMM"
                                                    // dateFormat="dd MMMM"
                                                    shouldCloseOnSelect
                                                    showPopperArrow={false}
                                                    calendarStartDay={1}
                                                    placeholderText="Select Date"
                                                    className="custom-datepicker-input"
                                                    filterDate={(date) => !isHoliday(date)}
                                                    dayClassName={(date) =>
                                                        isHoliday(date) ? "react-datepicker__day--holidayClass" : undefined
                                                    }
                                                    locale={{
                                                        localize: {
                                                            month: (n) => monthNames[n],
                                                            day: (n) => [t("sun"), t("mon"), t("tue"), t("wed"), t("thu"), t("fri"), t("sat")][n]
                                                        },
                                                        formatLong: {
                                                            date: () => "EEE dd MMMM"
                                                        }
                                                    }}
                                                />
                                            </label>
                                            </div>

                                            {/* ================= ZONE DROPDOWN ================= */}
                                            <div
                                                ref={zoneDropdownRef}
                                                className="employee-list location-list"
                                                style={{ position: "relative" }}
                                            >
                                                <div
                                                    role="button"
                                                    onClick={() => setZoneOpen(!zoneOpen)}
                                                    className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <div className="d-flex flex-column justify-content-center">
                                                        <p className="sub-dropdown-name">{t("zone")}</p>
                                                        <span
                                                            style={{
                                                                fontSize: "16px",
                                                                fontWeight: "bold",
                                                                color: "#1c988a",
                                                            }}
                                                        >
                                                            {selectedZone?.ZoneName || t("select_a_zone")}
                                                        </span>
                                                    </div>
                                                </div>

                                                {zoneOpen && (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "calc(100% + 6px)",
                                                            left: 0,
                                                            width: "100%",
                                                            background: "#fff",
                                                            borderRadius: 12,
                                                            boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                                            maxHeight: 300,
                                                            overflowY: "auto",
                                                            zIndex: 9999,
                                                        }}
                                                    >
                                                        {zones.length > 0 ? (
                                                        zones.map((zone) => (
                                                            <div
                                                                key={zone.Id}
                                                                onClick={() => {
                                                                    updateSelectedZone(zone, bookingDate);
                                                                    setZoneOpen(false);
                                                                }}
                                                                style={{
                                                                    padding: "8px 12px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    fontSize:"12px"
                                                                }}
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    checked={selectedZone?.Id === zone.Id}
                                                                    readOnly
                                                                    style={{
                                                                        marginRight: 8,
                                                                        accentColor: "#1c988a",
                                                                    }}
                                                                />
                                                                <span>{zone.ZoneName}</span>
                                                            </div>
                                                        ))
                                        ) : (
                                          <div style={{ padding: "8px 12px", color: "#9ca3af" }}>
                                            {t("no_zones_available")}
                                          </div>
                                        )}
                                            </div>
                                                )}
                                                </div>

                                            {/* ================= MEMBER DROPDOWN ================= */}
                                            <MemberBookingDropdown
                                                teamMemberList={teamMemberList}
                                                teamsList={teamsList}
                                                selectedTeamMember={selectedTeamMember}
                                                selectedTeamId={selectedTeamId}
                                                isGuest={isGuest}
                                                onMemberSelect={handleMemberSelection}
                                                onTeamSelect={handleTeamSelection}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        {showFilter && zoneData?.TagListData && (
                            <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                            >
                                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                    <div className="modal-content modal-radius">
                                        <div>
                                            {/* <CommonFilter
                                                tagListData={zoneData?.TagListData}
                                                selectedZone={selectedZone}
                                                onApply={(filters) => {
                                                    // 👇 This log will show all arguments being passed to the function
                                                    console.log("🚀 Fetching Zone Data with params:", {
                                                        selectedZone,
                                                        bookingDate,
                                                        selectedTeamMember,
                                                        selectedTeamId,
                                                        isGuest,
                                                        filters
                                                    });

                                                    fetchZoneData(
                                                        selectedZone,
                                                        bookingDate,
                                                        selectedTeamMember,
                                                        selectedTeamId,
                                                        isGuest,
                                                        filters
                                                    );
                                                }}
                                                onClose={() => setShowFilter(false)}
                                            /> */}
                                            <CommonFilter
                                                bookingDate={bookingDate}
                                                tagListData={zoneData?.TagListData}
                                                selectedZone={selectedZone}
                                                onApply={(filters) => {
                                                    setFilters(getStoredFilters(selectedZone.Id));

                                                    fetchZoneData(
                                                        selectedZone,
                                                        bookingDate,
                                                        selectedTeamMember,
                                                        selectedTeamId,
                                                        isGuest,
                                                        filters
                                                    );
                                                    setShowFilter(false);
                                                }}
                                                onClose={() => setShowFilter(false)}
                                            />
                                        </div></div>
                                </div>
                            </div>
                        )}
                            <div className="col-md-2">
                                <div className="menu-bar-options d-flex justify-content-end gap-3">
                                    {zoneTypeforUserIcon == 1 &&
                                        <a
                                            className="d-flex align-items-center justify-content-center cursor-pointer"
                                            onClick={() => setShowRoleIcons(prev => !prev)}
                                        >
                                            {showRoleIcons ? <img src={RoleIcon} alt="Roll" /> : <img src={RoleIconWhite} alt="Roll"></img>}
                                        </a>
                                    }
                                    {zoneCreditValue !== 0 && isGuest == 0 &&
                                        <div className="credit-info">
                                             <CreditInfoCard
                                            userZoneCreditValue={zoneCreditValue}
                                            userZoneCreditBalance={selectedMemberCredit}
                                            creditBalanceRefillEvery={selectedMemberCreditBalanceRefillEvery}
                                            IsThumbnailPresent={isThumbnailPresent}
                                            CompanyId={companyId}
                                            creditPersonName={selectedCreditPersonName}
                                        />
                                            {/* <a href="#" className="orange-outline-with-icon flex-column">
                                                <img src={OrangeStar} alt="" />
                                                <span className='d-block'>{selectedMemberData?.Credit}</span>
                                            </a>
                                            <div className="credit-info-inner text-center">
                                                <div className="profile-info-inner">
                                                    <div className="profile-img">
                                                        <img
                                                            src={Profile}
                                                            alt="" className="img-fluid" />
                                                    </div>
                                                    <div className="profile-name">
                                                        <h5>{getFirstName()}</h5>
                                                    </div>
                                                    <div className="profile-location d-flex justify-content-center align-items-center">
                                                        <img src={ProfileLocation} alt="" />
                                                        <p>Galway.IE</p>
                                                    </div>
                                                </div>
                                                <div className="credit-balance-info">
                                                    <div className="credit-balance d-flex justify-content-between align-items-center">
                                                        <p>Credit balance</p>
                                                        <h6>{selectedMemberData?.Credit}</h6>
                                                    </div>
                                                    <div className="credit-balance-btn">The credit balance reset <a href="#"> every {creditBalanceRefill} </a></div>
                                                </div>
                                                <div className="credit-details-lists">
                                                    <div className="list-card">
                                                        <img src={FillStar} alt="" className="img-fluid" />
                                                        <p>Use credits to book spaces</p>
                                                    </div>
                                                    <div className="list-card">
                                                        <img src={GrayStar} alt="" className="img-fluid" />
                                                        <p>Same day, no credits needed</p>
                                                    </div>
                                                    <div className="list-card">
                                                        <img src={BlackClose} alt="" className="img-fluid" />
                                                        <p>Release booking for refund</p>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    }
                                    

                                {/* <div className="col-md-3"> */}
                                    <div className="menu-bar-options d-flex justify-content-end gap-3">
                                        {/* <CreditInfoCard
                                            userZoneCreditValue={1}
                                            userZoneCreditBalance={creditBalance}
                                            creditBalanceRefillEvery={creditBalanceRefillEvery}
                                            IsThumbnailPresent={isThumbnailPresent}
                                            CompanyId={companyId}
                                        /> */}
                                        <div className="notification-info">
                                            <a href="#" data-bs-toggle="offcanvas" data-bs-target="#notification-panel" aria-controls="notification-panel" className="position-relative notification-icon">
                                                <img src={notificationicon} alt="" />
                                                {hasUnreadNotifications && (
                                                    <span className="orange-dot"></span>
                                                )}</a>
                                        </div>
                                        <NotificationPanel onUnreadChange={setHasUnreadNotifications} />
                                        {/* <div className="profile-info">
                                        <div className="dropdown dropdwon-green">
                                            <a href="#" className="profileImg" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src={profileImg} alt="" />
                                            </a>
                                        </div>
                                    </div> */}
                                    </div>
                                {/* </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="component-area">
                    <Sidebar
                        IsThumbnailPresent={isThumbnailPresent}
                        CompanyId={companyId}
                    />
                {/* </div> */}

            <div  className="pt-96 pb-96 active-cont my-container" style={{ minHeight: "calc(100vh - 80px)", position: "relative" }}>
                {loading ? (
                    <div id='preloader'>
                        <img src={LoaderFull} alt="Loading" />
                    </div>
                ) : !selectedZone ? (
                    <div className="text-center mt-5">
                        {/* {t("please_select_a_zone")} */}
                    </div>
                ) : selectedZone.MapType === 2 && zoneData ? (
                    <MapGridZone
                        zoneData={zoneData}
                        selectedZone={selectedZone}
                        bookingDate={bookingDate}
                        setBookingDate={setBookingDate}
                        teamLeadFlag={teamLeadFlag}
                        handleDateChange={handleDateChange}
                        vehicleIds={Array.isArray(vehicleType) ? vehicleType : []}
                        // bookingtimeSlots={Array.isArray(bookingtimeSlots) ? bookingtimeSlots : []}
                        bookingtimeSlots={zoneData?.Layout || []}
                        startDate={startDate}
                        changeddate={changeddate}
                        setStartDate={setStartDate}
                        setchangeddate={setchangeddate}
                        spotVehicleMap={spotVehicleMap}
                        vehicleMap={vehicleMap}
                        GuestVehicle={GuestVehicle}

                        // teamMemberGuId={selectedTeamMember}
                        LoaderFull={LoaderFull}
                        teamMemberGuId={selectedTeamMember}
                        teamId={selectedTeamId}
                        safeIsGuest={isGuest ?? 0}
                        zoneCreditValue={zoneCreditValue}
                        individualDayCost={individualDayCost}
                        refreshZoneAfterBooking={refreshZoneAfterBooking}
                        showRoleIcons={showRoleIcons}

                        showBookingForStaff={showBookingForStaff}
                        showAvailabilityColour={showAvailabilityColour}
                        mapFontSize={mapFontSize}

                        preBookingQue={preBookingQue}
                        parkingInformationImage={parkingInformationImage}
                        zoneTypeforUserIcon={zoneTypeforUserIcon}
                        removeBanner={removeBanner}
                        
                        leaveQueueParam={leaveQueueParam}
                        joinQueuueParam={joinQueuueParam}
                        queuePositoin={queuePositoin}

                        checkInBtn={checkInBtn}
                        checkOutBtn={checkOutBtn}
                        checkInFlag={checkInFlag}
                        syncZoneUiFlagsFromRecords={syncZoneUiFlagsFromRecords}
                        syncCreditInfoFromRecords={syncCreditInfoFromRecords}

                        selectedName={selectedName}
                        selectedMemberData={selectedMemberData}
                        CellLoader={CellLoader}
                        mapZoomLevel={mapZoomLevel}
                        WarningIcon={WarningIcon}
                        WarningcloseIcon={WarningcloseIcon}
                        isHoliday={isHoliday}
                        guestConfirmation={guestConfirmation}
                    />
                ) : selectedZone.MapType === 3 && zoneData ? (
                    <MapCanvasZone
                        zoneData={zoneData}
                        selectedZone={selectedZone}
                        bookingDate={bookingDate}
                        setBookingDate={setBookingDate}
                        teamLeadFlag={teamLeadFlag}
                        handleDateChange={handleDateChange}
                        vehicleIds={Array.isArray(vehicleType) ? vehicleType : []}
                        // bookingtimeSlots={Array.isArray(bookingtimeSlots) ? bookingtimeSlots : []}
                        bookingtimeSlots={zoneData?.Layout || []}
                        startDate={startDate}
                        changeddate={changeddate}
                        setStartDate={setStartDate}
                        setchangeddate={setchangeddate}
                        vehicleMap={vehicleMap}
                        GuestVehicle={GuestVehicle}

                        // teamMemberGuId={selectedTeamMember}
                        LoaderFull={LoaderFull}
                        teamMemberGuId={selectedTeamMember}
                        teamId={selectedTeamId}
                        safeIsGuest={isGuest ?? 0}
                        zoneCreditValue={zoneCreditValue}
                        individualDayCost={individualDayCost}
                        refreshZoneAfterBooking={refreshZoneAfterBooking}
                        showRoleIcons={showRoleIcons}

                        showBookingForStaff={showBookingForStaff}
                        showAvailabilityColour={showAvailabilityColour}
                        mapFontSize={mapFontSize}

                        preBookinQueCanvas={preBookinQueCanvas}
                        parkingInformationImage={parkingInformationImage}
                        zoneTypeforUserIcon={zoneTypeforUserIcon}

                        leaveQueueParam={leaveQueueParam}
                        joinQueuueParam={joinQueuueParam}
                        queuePositoin={queuePositoin}

                        checkInBtn={checkInBtn}
                        checkOutBtn={checkOutBtn}
                        checkInFlag={checkInFlag}
                        syncZoneUiFlagsFromRecords={syncZoneUiFlagsFromRecords}

                        selectedName={selectedName}
                        selectedMemberData={selectedMemberData}
                        CellLoader={CellLoader}
                        mapZoomLevel={mapZoomLevel}
                        WarningIcon={WarningIcon}
                        WarningcloseIcon={WarningcloseIcon}
                        isHoliday={isHoliday}
                        guestConfirmation={guestConfirmation}
                    />
                ) : (
                    <div className="text-center mt-5">
                        <img src={NoMap} alt="nomap" />
                       <p> <span>{t("react_navigate_to_calendar")}</span> </p>
                    </div>
                )}
            </div>
</div>
{renderApiUi(loading)}

        </div>
    );
}
